import { render, staticRenderFns } from "./addSalesTerritory.vue?vue&type=template&id=6491cd7e&scoped=true"
import script from "./addSalesTerritory.vue?vue&type=script&lang=js"
export * from "./addSalesTerritory.vue?vue&type=script&lang=js"
import style0 from "./addSalesTerritory.vue?vue&type=style&index=0&id=6491cd7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6491cd7e",
  null
  
)

export default component.exports